import React from 'react';
import { useAuth } from '../context/AuthContext';

const Profile: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="profile">
      {/* Personal Information */}
      <div className="ps">
        <div className="ps-t">Personal Information</div>
        <div className="pr">
          <span className="pr-l">First Name</span>
          <span className="pr-v">{user?.firstName || 'N/A'}</span>
        </div>
        <div className="pr">
          <span className="pr-l">Last Name</span>
          <span className="pr-v">{user?.lastName || 'N/A'}</span>
        </div>
        <div className="pr">
          <span className="pr-l">Email</span>
          <span className="pr-v">{user?.email || 'N/A'}</span>
        </div>
      </div>

      {/* Account Settings */}
      <div className="ps">
        <div className="ps-t">Account Settings</div>
        <div className="pr">
          <span className="pr-l">Role</span>
          <span className="pr-v">Patient</span>
        </div>
        <div className="pr">
          <span className="pr-l">Account Status</span>
          <span className="pr-v" style={{ color: 'var(--green)', fontWeight: 600 }}>Active</span>
        </div>
      </div>

      {/* Login & Security */}
      <div className="ps">
        <div className="ps-t">Login &amp; Security</div>
        <div className="pr">
          <span className="pr-l">MFA</span>
          <span className="pr-v" style={{ color: 'var(--green)', fontWeight: 600 }}>Enabled</span>
        </div>
        <div className="pr">
          <span className="pr-l">Need Help?</span>
          <span className="pr-v">
            <a href="mailto:info@silverscribe.ca" style={{ color: 'var(--primary)', fontWeight: 700, textDecoration: 'none' }}>
              Contact Support
            </a>
          </span>
        </div>
      </div>

      <style>{`
        .ps {
          background: var(--white);
          border: 1px solid var(--border);
          border-radius: var(--radius);
          padding: 28px;
          margin-bottom: 20px;
          box-shadow: var(--shadow-sm);
        }
        .ps-t {
          font-family: var(--font-display);
          font-size: 20px;
          font-weight: 700;
          color: var(--text);
          margin-bottom: 20px;
          padding-bottom: 14px;
          border-bottom: 1px solid var(--border);
        }
        .pr {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 14px 0;
          border-bottom: 1px solid var(--border);
        }
        .pr:last-child {
          border-bottom: none;
        }
        .pr-l {
          font-weight: 700;
          font-size: 15px;
          color: var(--text-muted);
          min-width: 160px;
        }
        .pr-v {
          font-size: 17px;
          color: var(--text);
          flex: 1;
          text-align: right;
        }

        @media (max-width: 768px) {
          .pr {
            flex-direction: column;
            gap: 0.25rem;
          }
          .pr-v {
            text-align: left;
          }
          .ps {
            padding: 20px;
          }
        }

        @media (max-width: 480px) {
          .ps {
            padding: 16px;
          }
          .pr-l, .pr-v {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Profile;
